import { Confirmation, RequestError } from '@CS/components/Popups';
import type { FieldsData } from '@CS/components/Form/Fields/types';
import type { SubmitHandler, FieldValues } from 'react-hook-form';
import type { RequestErrorInfo } from '@/services/api/types';
import { Description, Fields } from '@CS/components/Form';
import type { User } from '@/services/api/types';
import { useState, useCallback } from 'react';
import { Submit } from '@/components/Popups';
import Logo from '@/assets/images/logo.png';
import { useLoader } from '@CS/hooks';
import CSS from './Form.module.css';
import API from '@/services/api';

type FormProps = {
  confirmPopup?: boolean;
  postcodeAPI?: string;
  user: User;
};

export const Form = ({
  confirmPopup = false,
  postcodeAPI,
  user
}: FormProps) => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  const [formError, setFormError] = useState<RequestErrorInfo>();
  const cancelForm = () => setFormError(void 0);

  const loader = useLoader(loading, { opacity: 0.5 });
  const [visiblePopup, setVisiblePopup] = useState(false);
  const [visibleSubmit, setVisibleSubmit] = useState(false);

  const onSubmit = useCallback(
    (data: FieldsData) => {
      const {
        emailAddress,
        phoneNumber,
        nationality,
        firstName,
        lastName,
        idNumber,
        terms,
        info
      } = data;

      const formData = {
        correctInformation: info,
        termsAcknowledged: terms,
        emailAddress,
        phoneNumber,
        nationality,
        firstName,
        lastName,
        idNumber
      };

      setVisiblePopup(confirmPopup);
      setLoading(!confirmPopup);
      setFormData(formData);

      API.updateUser({ data: { formData } })
        .then(() => setVisibleSubmit(true))
        .catch((error) =>
          ~setLoading(false) && setFormError(API.getRequestErrorInfo(error))
        );
    },
    [user.email]
  ) as SubmitHandler<FieldValues>;

  const onConfirm = useCallback(async () => {
    setVisiblePopup(false);
    setLoading(true);
  }, [formData]);

  return (
    <section className={CSS.formScreen}>
      <img src={Logo} />

      <div className={CSS.contentWrapper}>
        <Description />

        <Fields
          isConfirming={confirmPopup}
          postcodeAPI={postcodeAPI}
          onSubmit={onSubmit}
          user={user}
        />
      </div>

      {visiblePopup && (
        <Confirmation
          onCancel={() => setVisiblePopup(false)}
          onSubmit={onConfirm}
          hideClose
        />
      )}

      {visibleSubmit && <Submit />}

      {formError && (
        <RequestError info={formError} onClose={cancelForm} />
      )}

      {loader}
    </section>
  );
};
